// components/MachineOverview.tsx

import React, { useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import './MachineOverview.css';
import { useNavigate } from 'react-router-dom';
import { updateRecord } from './DataHandler';
import { deleteRecord, fetchRecordsByEmail } from './DataHandler';
import { FaTrash as FaTrashIcon } from 'react-icons/fa';
const FaTrash = FaTrashIcon as any;

interface Record {
  mac: string;
  name?: string[];
  in?: number[];
  out?: number[];
  type?: number;
  temperature?: number; // ✅ temp → temperature
  humidity?: number;    // ✅ humi → humidity
}

interface MachineOverviewProps {
  mqttMessage: string;
}

const MachineOverview: React.FC<MachineOverviewProps> = ({ mqttMessage }) => {
  const [email, setEmail] = useState('');
  const [records, setRecords] = useState<Record[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const email = token ? (jwt_decode(token) as { email: string }).email : '';
    setEmail(email);
  }, []);

  useEffect(() => {
    if (email) {
      fetchRecordsByEmail(email)
        .then((data) => {
          const updated = data.map((rec: any) => ({
            ...rec,
            temperature: rec.temperature ?? rec.temp,
            humidity: rec.humidity ?? rec.humi,
          }));
          setRecords(updated);
        })
        .catch((error) => console.error('Error fetching records:', error));
    }
  }, [email]);


  /*
  useEffect(() => {
    if (email) {
      fetchRecordsByEmail(email)
        .then((data) => setRecords(data))
        .catch((error) => console.error('Error fetching records:', error));
    }
  }, [email]);
  */

  useEffect(() => {
    if (mqttMessage && email) {
      try {
        const parsedMessage = JSON.parse(mqttMessage);

        if (parsedMessage.email === email) {
          setRecords((prevRecords) => {
            const existingRecordIndex = prevRecords.findIndex(
              (record) => record.mac === parsedMessage.mac
            );

            if (existingRecordIndex >= 0) {
              return prevRecords.map((record, index) =>
                index === existingRecordIndex
                  ? {
                      ...record,
                      in: parsedMessage.in,
                      out: parsedMessage.out,
                      type: parsedMessage.type,
                      temperature: parsedMessage.temperature ?? parsedMessage.temp,
                      humidity: parsedMessage.humidity ?? parsedMessage.humi,
                    }
                  : record
              );
            }

            return [
              ...prevRecords,
              {
                mac: parsedMessage.mac,
                name: parsedMessage.name || parsedMessage.mac,
                in: parsedMessage.in || [],
                out: parsedMessage.out || [],
                type: parsedMessage.type,
                temperature: parsedMessage.temperature ?? parsedMessage.temp,
                humidity: parsedMessage.humidity ?? parsedMessage.humi,
              },
            ];
          });

          updateRecord(parsedMessage.mac, parsedMessage).catch((error) =>
            console.error('Error upserting data:', error)
          );
        }
      } catch (error) {
        console.error('MQTT 메시지 파싱 오류:', error);
      }
    }
  }, [mqttMessage, email]);

  const handleDelete = async (mac: string) => {
    if (window.confirm('정말로 삭제하시겠습니까?')) {
      try {
        await deleteRecord(mac);
        setRecords((prevRecords) => prevRecords.filter((record) => record.mac !== mac));
        alert('삭제되었습니다.');
      } catch (error) {
        console.error('Error deleting record:', error);
        alert('삭제 중 오류가 발생했습니다.');
      }
    }
  };
  

  return (
    <div className="machine-overview">
      <table className="machine-table">
        <thead>
          <tr className="table-header">
            <th>이름</th>
            <th>모니터</th>
          </tr>
        </thead>
        <tbody>
          {records.length > 0 ? (
            records.map((record) => (
              <tr key={record.mac}>
                <td>
                  <span
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    onClick={() => navigate(`/device/${record.mac}`)}
                  >
                    {record.name && Array.isArray(record.name) && record.name.length > 0 ? record.name[0] : record.mac}
                  </span>
                </td>
                <td>
                  <div className="monitor-container">
                    <div className="led-row">
                      <span>&nbsp;입력:</span>
                      {record.in?.map((state, index) => (
                        <div
                          key={`in-${index}`}
                          className={`led ${state === 1 ? 'led-on' : 'led-off'}`}
                        ></div>
                      ))}

                      <span>&nbsp;&nbsp;출력:</span>
                      {record.out?.map((state, index) => (
                        <div
                          key={`out-${index}`}
                          className={`led ${state === 1 ? 'led-on' : 'led-off'}`}
                        ></div>
                      ))}
                    
                      {(record.temperature !== undefined || record.humidity !== undefined) && (
                        <span>
                          {record.temperature !== undefined && (
                            <span>&nbsp;&nbsp;온도: {record.temperature}°C</span>
                          )}
                          {record.humidity !== undefined && (
                            <span>&nbsp;&nbsp;습도: {record.humidity}%</span>
                          )}
                        </span>
                      )}
                      
                      {/* 휴지통 아이콘 추가 */}
                      <FaTrash
                        style={{ cursor: 'pointer', marginLeft: '10px', color: 'red' }}
                        onClick={() => handleDelete(record.mac)}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2}>등록된 장치가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </table>
      
      <p style={{ color: 'black', marginBottom: '0px', textAlign: 'left' }}>
        처음 접속한 기기는 reset 키를 눌러 주세요.
      </p>
    </div>
  );
};

export default MachineOverview;
